module.exports = __webpack_public_path__ + "img/alertbell_mobile.325d25ea.png";